<template>
    <div>
      <span v-if="debug === 'true' || debug === true">{{version}}</span>
        <b-container fluid>

            <b-row>
              <b-col class="subtitulos">
                Generación de reporte de Ptis en revision
              </b-col>
            </b-row>
            <div class="mt-2 col-md-12"></div>

            <validation-observer ref="observer" v-slot="{ handleSubmit }">
                <b-form @submit.stop.prevent="handleSubmit(buscar)">
                  <b-row>
                    <b-col>
                      <b-row>
                        <b-col cols="4">
                            <validation-provider name="fcInicioVal" :rules="{ required: true }" v-slot="validationContext">
                                <label>Fecha inicio:<validacion/></label>
                                <b-input-group size="sm" class="mb-2">
                                  <b-form-datepicker placeholder="Fecha inicio"
                                                     :max="new Date()"
                                                     @input="fechaMaxima($event)"
                                  ></b-form-datepicker>
                                </b-input-group>
                                <validacion :texto="validationContext.errors[0] ? validationContext.errors[0] : ' '"/>
                              </validation-provider>
                        </b-col>
                        <b-col cols="4">
                            <validation-provider name="fcFinVal" :rules="{ required: true }" v-slot="validationContext">
                              <label>Fecha fin:<validacion/></label>
                              <b-input-group size="sm" class="mb-2">
                                <b-form-datepicker placeholder="Fecha fin"
                                                   v-model="filtro.fechaFin"
                                                   :max="filtro.fechaInicio.addDays(diasMaximoMes) > new Date() ? new Date(): filtro.fechaInicio.addDays(diasMaximoMes)"
                                                   :min="filtro.fechaInicio"
                                ></b-form-datepicker>
                              </b-input-group>
                              <validacion :texto="validationContext.errors[0] ? validationContext.errors[0] : ' '"/>
                            </validation-provider>
                          </b-col>
                      </b-row> 
                    </b-col>  
                  </b-row>  
                </b-form>
            </validation-observer>

            <b-row>
                <b-col>
                  <b-row align-v="center" align-h="end">
                    <b-col>
                      <download-excel
                          v-if="datosTabla.length > 0 && $localStorageService.can('Rep_M2_revision')"
                          :data="datosTabla"
                          class="btn btn-primary"
                          :fields="fieldsExcel"
        
                          worksheet="My Worksheet"
                          name="reportePtisRevision.xls"
                      >
                        Generar Excel
                      </download-excel>
                    </b-col>
        
        
                    <b-col cols="2" align="right">
                        <b-button v-b-tooltip.hover title="Generar reporte" variant="outline-success"
                                  @click="generar()" :disabled="loader">Generar
                        </b-button>
                      </b-col>
        
                  </b-row>
                </b-col>
              </b-row>
              <div class="mt-2 col-md-12"></div>

              <b-row>
                <b-col cols="12">
                  <b-table
                      thead-tr-class="columnas"
                      :items="datosTabla"
                      :fields="fields"
                      :per-page="$registrosPorPaginaTabla"
                      :current-page="paginaActual"
                      responsive="true"
                      class="parrafos"
                      fixed>
                    
                  </b-table>
                  <div align="center" v-if="loader">
                    <b-spinner variant="primary" label="Spinning"></b-spinner>
                  </div>
                  <b-col v-if="!loader">
                    <b-alert v-if="datosTabla!==undefined && datosTabla.length === 0" variant="warning" show>No hay datos
                    </b-alert>
                  </b-col>
                  <b-col v-if="!loader">
                    <b-pagination
                        v-if="datosTabla !== undefined && datosTabla.length > 15"
                        align="center"
                        v-model="paginaActual"
                        :total-rows="datosTabla.length"
                        :per-page="$registrosPorPaginaTabla"
                        aria-controls="tabla"
                    ></b-pagination>
                  </b-col>
                </b-col>
              </b-row>

        </b-container>   
    </div>
</template>





<script>
import {required} from "vuelidate/lib/validators";

export default {
  name: "reportePtiRevision",
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,

    diasMaximoMes: null,
    datosTabla: [],
    fields: [],
    paginaActual: 1,
    rf:null,
    loader: false,
    filtro: {
      fechaInicio: null,
      fechaFin: null,
    },
    fieldsExcel: {
      "Clinica":"clinica",
      "EE/Unidad de presentación":"nombreEmbajador",
      "Id Pti": "idPti",
      "Nombre Px":"nombrePaciente",
      "Id del Px":"idPaciente",
      "Ciclo": "ciclo",
      "Hora Inicio Revisión":"fechaInicio",
      "Hora Fin Revisión": "fechaFin",
      "Estatus Revisión": "estatusRevision",
    },
    fieldsExcelDetalle: {
      "Clinica":"clinica",
      "EE/Unidad de presentación":"nombreEmbajador",
      "Id Pti": "idPti",
      "Nombre Px":"nombrePaciente",
      "Id del Px":"idPaciente",
      "Ciclo": "ciclo",
      "Hora Inicio Revisión":"fechaInicio",
      "Hora Fin Revisión": "fechaFin",
      "Estatus Revisión": "estatusRevision",
      

    },
  }),
  validations: {
    filtro: {
      fechaInicio: {required},
      fechaFin: {required},
    }
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
  },
  methods: {
    fechaMaxima(event){
      this.diasMaximoMes = this.$moment(event).daysInMonth();
      this.filtro.fechaInicio = new Date(event);
      this.filtro.fechaFin = null;

    },
    dateDisabled(ymd, date) {
        const weekday = date.getDay();
        return weekday >= 1 && weekday <= 5;
     
    },
    generar() {
      this.loader = true;
      this.datosTabla = [];
      this.fields = [];
      
      let filtro={
        fechaInicio:this.filtro.fechaInicio,
        fechaFin:new Date(this.filtro.fechaFin)
      }
      this.$http.post(this.$api + 'reportes/obtenerReportePtisRevision', filtro).then(respuesta => {
        if (respuesta.data.data) {

          this.fields.push({key: "clinica", label: "Clinica", sortable: true});
          this.fields.push({key: "nombreEmbajador", label: "EE/Unidad de presentación", sortable: true});
          this.fields.push({key: "idPti", label: "Id Pti", sortable: true});
          this.fields.push({key: "nombrePaciente", label: "Nombre Px", sortable: true});
          this.fields.push({key: "idPaciente", label: "Id del Px", sortable: true});
          this.fields.push({key: "ciclo", label: "Ciclo", sortable: true});
          this.fields.push({key: "fechaInicio", label: "Hora Inicio Revisión", sortable: true});
          this.fields.push({key: "fechaFin", label: "Hora Fin Revisión", sortable: true});
          this.fields.push({key: "estatusRevision", label: "Estatus Revisión", sortable: true});

          respuesta.data.data.forEach(element => {
            let obj = {
              ciclo: element.ciclo,
              clinica: element.clinica,
              estatusRevision: element.estatusRevision,
              fechaFin: element.fechaFin == "No hay fecha" ? element.fechaFin : this.$moment(new Date(element.fechaFin)).format('ll'),
              fechaInicio: element.fechaInicio == "No hay fecha" ? element.fechaInicio : this.$moment(new Date(element.fechaInicio)).format('ll'),
              idPaciente: element.idPaciente.toString(),
              idPti: element.idPti,
              nombreEmbajador: element.nombreEmbajador,
              nombrePaciente: element.nombrePaciente,
            }
            this.datosTabla.push(obj)
          })
        }
      }).finally(() => {
        this.loader = false;
        this.paginaActual = 1;
      })
    },
    validateState(name) {
      const {$dirty, $error} = this.$v.filtro[name];
      return $dirty ? !$error : null;
    },
  }

}
</script>

<style scoped>
</style>